// extracted by mini-css-extract-plugin
export default {"component":"VehiclePhotoBlock-module__component-OSmN","label":"VehiclePhotoBlock-module__label-a2qh","skippedLabel":"VehiclePhotoBlock-module__skippedLabel-FPaP"};